// Currency List with symbols
export const currency = [
	{ code: 'EUR', symbol: '€' },
	{ code: 'ALL', symbol: 'Lek' },
	{ code: 'BAM', symbol: 'KM' },
	{ code: 'BRL', symbol: 'R$' },
	{ code: 'GBP', symbol: '£' },
	{ code: 'BGN', symbol: 'Лв.' },
	{ code: 'XOF', symbol: 'CFA' },
	{ code: 'CNY', symbol: '¥' },
	{ code: 'CRC', symbol: '₡' },
	{ code: 'HRK', symbol: 'kn' },
	{ code: 'CZK', symbol: 'Kč' },
	{ code: 'DKK', symbol: 'Kr.' },
	{ code: 'GNF', symbol: 'FG' },
	{ code: 'HUF', symbol: 'Ft' },
	{ code: 'ISK', symbol: 'kr' },
	{ code: 'ILS', symbol: '₪' },
	{ code: 'JPY', symbol: '¥' },
	{ code: 'MKD', symbol: 'ден' },
	{ code: 'MGA', symbol: 'Ar' },
	{ code: 'MUR', symbol: '₨' },
	{ code: 'MXN', symbol: '$' },
	{ code: 'MDL', symbol: 'L' },
	{ code: 'NOK', symbol: 'kr' },
	{ code: 'PLN', symbol: 'zł' },
	{ code: 'RON', symbol: 'lei' },
	{ code: 'RUB', symbol: '₽' },
	{ code: 'RSD', symbol: 'din' },
	{ code: 'SEK', symbol: 'kr' },
	{ code: 'CHF', symbol: 'CHF' },
	{ code: 'TND', symbol: 'ت.د' },
	{ code: 'TRY', symbol: '₺' },
	{ code: 'USD', symbol: '$' },
];

// Default page size and page number
export const defaultPageSize = 10;
export const defaultPageNumber = 1;
export const defaultPageSizeForInfiniteScroll = 0;
export const defaultPageSizePopup = 10;

export const PASSWORD_VALIDATION_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_])[a-zA-Z0-9!@#$%^&*_]{8,16}$/;

// HERE: Temporary datas ONLY FOR MOCK!
export const mockGroupId = null;
export const mockMerchantId = '101';
export const mockStoreId = '0';

//  Admin ENUM
export const adminEnum = {
	ENUM_NEXI: '1',
	ENUM_GROUP_ADMIN: '2',
	ENUM_MERCHANT_ADMIN: '3',
	ENUM_USER_READER_VAS: '4',
};
